import React from "react";
import ReactDOM from 'react-dom';
import PropTypes from "prop-types";

class IndeterminateCheckbox extends React.Component {
    componentDidMount() {
        if (this.props.indeterminate === true) {
            this._setIndeterminate(true);
        }
    }

    componentDidUpdate(previousProps) {
        if (previousProps.indeterminate !== this.props.indeterminate) {
            this._setIndeterminate(this.props.indeterminate);
        }
    }

    _setIndeterminate(indeterminate) {
        const node = ReactDOM.findDOMNode(this);
        node.indeterminate = indeterminate;
    }

    render() {
        // const { indeterminate, type, ...props } = this.props;
        return <input type="checkbox" {...this.props} />;
    }
}

IndeterminateCheckbox.propTypes = {
	indeterminate: PropTypes.bool
};

export default IndeterminateCheckbox;

//how to use
//   render() {
//     return <IndeterminateCheckbox
//              checked={this.props.state === "checked"}
//              indeterminate={this.props.state === "indeterminate"}
//              ... />
//   }
